import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeWhiteSpace',
  standalone: true,
})
export class RemoveWhiteSpacePipe implements PipeTransform {
  transform(value: string): boolean {
    if (!value) return false;

    const str = value.replace(/<\/?[^>]+(>|$)|\s+/g, "")
    return str.length > 0;
  }
}
